var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTemplates48X48 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24.003,
    viewBox: "0 0 22 24.003",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_choose_termplate",
    d: "M966.9,551.733l4.48-4.539H966.9Zm-6.475-19.308a2.346,2.346,0,1,0-2.355-2.346A2.346,2.346,0,0,0,960.422,532.425Zm8.205-2.161h-3.891q.015.174.015.351a4.375,4.375,0,0,1-8.748,0q0-.177.015-.351h-3.891a2.722,2.722,0,0,0-2.75,2.686v16.1a2.72,2.72,0,0,0,2.75,2.686h13.284v-5.221a.71.71,0,0,1,.717-.7h5.249V532.95A2.723,2.723,0,0,0,968.627,530.264Zm-6.144,15.868h-8.517a.7.7,0,1,1,0-1.405h8.517a.7.7,0,0,1,0,1.405Zm4.3-2.811H953.966a.7.7,0,1,1,0-1.4h12.822a.7.7,0,0,1,0,1.4Zm-13.534-3.514a.71.71,0,0,1,.717-.7h11.387a.7.7,0,0,1,0,1.405H953.966a.71.71,0,0,1-.717-.7Zm13.539-2.108H953.966a.7.7,0,1,1,0-1.4h12.822a.7.7,0,0,1,0,1.4Z",
    transform: "translate(-949.377 -527.733)",
    fill: "#00a1af"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTemplates48X48);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_templates48x48.56001969b3a2d87a9408fb3947028468.svg";